import {Component, OnDestroy, OnInit} from '@angular/core';
import {takeUntil} from "rxjs/operators";
import {ActivatedRoute} from "@angular/router";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatDialog} from "@angular/material/dialog";
import {AuthService} from "../../../../shared/services/auth.service";
import {ReplaySubject} from "rxjs";
import {UserPermissions} from "../../../../shared/interface/user-permissions";
import {HttpErrorResponse} from "@angular/common/http";
import {Tag} from "../../../../shared/interface/tag";
import {TagService} from "../../../../shared/services/tag.service";

@Component({
  selector: 'app-tags-details',
  templateUrl: './tags-details.component.html',
  styleUrls: ['./tags-details.component.scss']
})
export class TagsDetailsComponent implements  OnInit, OnDestroy  {


  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  tagId: string;
  tagObject?: Tag;
  tag: ReplaySubject<Tag> = new ReplaySubject<Tag>(1);
  modify = false;
  userPermissions: ReplaySubject<UserPermissions>;

  constructor(
    private route: ActivatedRoute,
    private snack: MatSnackBar,
    private dialog: MatDialog,
    private auth: AuthService,
    private tagService: TagService,
  ) {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
    this.route.params
      .pipe(takeUntil(this.destroyed$))
      .subscribe(params => {
        this.tagId = params.id;
        this.load();
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  load(): void {
    this.tagService.get(this.tagId).subscribe((tag: Tag) => {
      this.tag.next(tag);
      this.tagObject = tag;
    }, (error: HttpErrorResponse) => {
      this.snack.open('Nie udało się pobrać danych ', error.status.toString(), {
        duration: 2000
      });
    });
  }
}
